import {FOOTER_MODULE} from "../footer-module.consts";
import {ActionHandler} from "../../../../../infrastructure/handlers/action-handler";

export class FooterModuleVersionClickDebugHandler extends ActionHandler {
  type = FOOTER_MODULE.ACTION_TYPES.versionClick;
  count: Number = 0;

  static injectables = [...ActionHandler.injectables];

  constructor() {
    super();

    this.count = 0;
  }

  async action() {
    if(this.count >= 3) {
      this.appStore.state._isDebugAvailable = true;
    }

    this.count++;
  }
}
